import { SocialPostEntity } from "@/modules/social/entities/socialEntity"
import type { ReactionSocialPostDto, SocialPostDto } from "@/modules/social/gateway/socialDto"
import { ReactionSocialPostEntityBuilder } from "@/modules/social/tests/reactionSocialPostEntity.builder"

export class SocialPostEntityBuilder {
  private dto: SocialPostDto

  static create() {
    return new SocialPostEntityBuilder()
  }

  protected constructor() {
    this.dto = {
      id: "post-1",
      text: null,
      medias: [],
      creationDate: "2025-01-20T10:00:00.000Z",
      reactions: ReactionSocialPostEntityBuilder.create().buildDto(),
      title: null,
      commentsNumber: 0,
    }
  }

  withId(id: string): this {
    this.dto.id = id
    return this
  }

  withComments(n: number): this {
    this.dto.commentsNumber = n
    return this
  }

  withReactions(reactionsDto: ReactionSocialPostDto): this {
    this.dto.reactions = reactionsDto
    return this
  }

  build(): SocialPostEntity {
    return SocialPostEntity.fromDto(this.dto)
  }

  buildDto(): SocialPostDto {
    return this.dto
  }
}
